import { Button, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import useSendSnackbar from "../../../../../hooks/useSendSnackbar";
import { ReactComponent as Circle } from "../../../../../assets/images/icon-info-circle.svg";

const useStyles = makeStyles({
  root: {
    maxWidth: "20rem"
  },
  header: {
    color: "#F52D5C",
    fontSize: "1rem",
    fontWeight: 600,
    marginBottom: "2rem"
  },
  infoBox: {
    backgroundColor: "#F1F9FF",
    padding: "1rem",
    borderRadius: "12px"
  },
  infoHeader: {
    display: "flex",
    color: "#212121",
    fontSize: "0.9rem",
    fontWeight: 600,
    alignItems: "center",
    "& > span": {
      marginLeft: "0.5rem"
    },

  },
  infoBody: {
    fontWeight: 400,
    fontSize: "0.9rem",
    color: "#616161"
  },

  footer: {
    display: "flex",
    justifyContent: "center",
    position: "absolute",
    backgroundColor: "#F3F4F9",
    left: "0",
    bottom: "0",
    padding: "1rem",
    width: "100%",
  },
  cancel: {
    margin: "0 0.85rem",
    backgroundColor: "#FFFFFF",
    color: "#212121"
  },
  continue: {
    margin: "0 0.85rem",
    backgroundColor: '#FEEAEE',
    color: "#F52D5C"
  }
})

const UnlinkUser = (props: any) => {
  const user = props.users.find((user: any) => user.id === props.id);
  const { t } = useTranslation();

  const classes = useStyles();

  const { sendSnackbar } = useSendSnackbar();

  const onCancel = () => {
    props.onDialogClose();
  }

  const onSubmit = async () => {
    props.onDeleteUser(props.venueId, props.id)
      .then(() => {
        sendSnackbar("userManagement.delete.success", "success");
        props.onDialogClose();
      })
      .catch((error: Error) => {
        sendSnackbar("userManagement.delete.failure", "error");
      });
  }

  //@TODO - fix this whole component
  
  return (
    <div className={classes.root}>
      <div className={classes.header}>{t("userManagement.delete.areYouSure", {firstName: user?.first_name, lastName: user?.last_name})}</div>
      <div className={classes.infoBox}>
        <div className={classes.infoHeader}>
          <Circle /> 
          <span>{t("userManagement.delete.otherVenues")}</span>
        </div>
        <p className={classes.infoBody}>{t("userManagement.delete.thisWillNot")}</p>
      </div>
      <div className={classes.footer}>
        <Button 
          className={classes.cancel}
          variant={"contained"} 
          onClick={onCancel}
        >
          {t("misc.cancel")}
        </Button>
        <Button 
          className={classes.continue}
          variant={"contained"} 
          onClick={onSubmit}
        >
          {t("misc.continue")}
        </Button>

      </div>
    </div>

  )
}

export default UnlinkUser;
